import React, { FC, useCallback } from 'react';

import { observer } from 'mobx-react';
import { useProfileWidgetStore } from './StoreProvider';
import { USER_TAGS } from '../interfaces';
import { Badge } from 'react-bootstrap';
import { USER_TAGS_BADGES } from '../../../customers/constants';
import { WidgetRow } from '../../../../../libs/ui-kit/widget-row/WidgetRow';

type Props = {};

export const TagsRow: FC<Props> = observer((_) => {
  const { profile: { tags } = {} } = useProfileWidgetStore();

  const renderTag = useCallback(
    (tag: USER_TAGS) => (
      <Badge key={tag} variant={USER_TAGS_BADGES[tag]}>
        {tag}
      </Badge>
    ),
    [],
  );

  if (!tags?.length) {
    return null;
  }

  return <WidgetRow label="Теги" value={tags.map(renderTag)} />;
});
